// todo 要優化把 49,meeting-room 兩個key對應到同一個{}
/* https://docs.google.com/document/d/1D8GpkV5t0oybSGPB-cPF7WsCkW3dkwsbNOtAMFlygao/edit?tab=t.0*/

const meetingRoomSeo = {
    metaTitle:'北中南會議室、活動場地租借－到空間便利店快速尋找理想地點',
    metaDescription:'會議室、活動場地租借就到空間便利店！據點遍佈全台北中南精華地段、價格透明，提供小型／中型／大型會議室出租服務，進行客戶會議、研討會、講座皆適宜！現在就到空間便利店，簡單3步驟預定您的理想空間！',
    section0: {
        h1: '北中南會議室、活動場地租借－到空間便利店快速尋找理想地點',
        p: '會議室、活動場地租借就到空間便利店！據點遍佈全台北中南精華地段、價格透明，提供小型／中型／大型會議室出租服務，進行客戶會議、研討會、講座皆適宜！現在就到空間便利店，簡單3步驟預定您的理想空間！'
    },
    section1: {
        resultTitle: '會議室租借',
        h2: '會議室租借價格多少？會議室出租方案與費用一覽',
        p: '我們提供多樣化的會議室選擇，並搭配彈性的租借方案，如時租、時段租與日租，無論您的需求為何，都能在這裡找到最合適的解決方案！',
        priceList: [
            {
                region: '北部時租價格',
                prices: [
                    { type: '小型會議室', price: '200～4,500／小時' },
                    { type: '中型會議室', price: '800～7,500／小時' },
                    { type: '大型會議室', price: '950～48,000／小時' }
                ]
            },
            {
                region: '中部時租價格',
                prices: [
                    { type: '小型會議室', price: '400～2,050／小時' },
                    { type: '中型會議室', price: '350～4,800／小時' },
                    { type: '大型會議室', price: '1,800～30,000／小時' }
                ]
            },
            {
                region: '南部時租價格',
                prices: [
                    { type: '小型會議室', price: '252～2,300／小時' },
                    { type: '中型會議室', price: '600～1,800／小時' },
                    { type: '大型會議室', price: '800～9,000／小時' }
                ]
            }
        ]
    },
    section2: {
        h2: '會議空間場地怎麼選？3 大要點要注意！',
        h3:'✨會議室大小與用途',
        list: [
            { p1: '小型會議室租借', p: '通常可容納 1 至 20 人，適合面試、商務洽談、小組討論等小型活動。' },
            { p1: '中型會議室租借', p: '通常可容納 20 至 100 人，適合尾牙春酒、教育訓練、展演等中型活動。' },
            { p1: '大型會議室租借', p: '通常可容納 100 人以上，適合研討會、講座、記者發表會等大型活動。' }
        ]
    },
    section2_1: {
        list:[
            {  h3:'會議室可用時段',
                p:'務必仔細核對場地的可用時段，包括確認您的會議日期和預計的起訖時間，並檢查您屬意的會議室是否在該時段內開放預訂，以提前確認場地在您所需的特定日期與時間是否能夠使用。'
            },
            {
                h3:'會議室位置與便利性',
                p:'盡可能選擇一個交通便捷、與會者能夠輕鬆抵達的會議場地。考量地點是否鄰近大眾運輸站點，例如捷運站、公車站、火車站，或是否有充足的停車位，都能大幅提升與會人員的便利性。'
            }

        ]
      },
    section3: {
        h2: '會議場地租借怎麼預約？會議室租借常見問題',
        list: [
            {
                h3: 'Q1：想租借會議室如何預約？',
                subTitle: '只要透過簡單 3 個步驟即可完成。',
                ul: ['選擇日期與時間，並點擊「立即預訂」按鈕。', '完成付款後，您將收到一封包含預訂詳細資訊的確認信。', '租借當天，只需在現場出示訂單 ID 即可使用空間。']
            },
            {
                h3: 'Q2：會議室租借超時怎麼辦？',
                subTitle: '為了確保所有用戶的權益，務必在預訂的時間內使用空間，請勿提早入場或超時離場。如有特殊需求，請提前與我們聯繫。',
                ul: []
            },
            {
                h3: 'Q3：租借會議室包含哪些基本設施？',
                subTitle: '每個空間擁有的設備不太一樣，但基本配備如會議桌椅、Wi-Fi、插頭、延長線等都會提供。',
                ul: []
            }
        ]
    },
    section4: {
        h2: '大、中、小型會議室租借台北找誰？就選空間便利店！',
        list: [
            {
                icon: 'seo_search',
                title: '快速搜尋，省時又便利',
                p: '透過我們便捷的關鍵字搜尋功能，系統能迅速篩選出符合您需求的會議空間，大幅節省您寶貴的時間。'
            },
            {
                icon: 'seo_house',
                title: '多元空間，滿足各種活動需求',
                p: '除了專業的會議室租借，我們也提供適合抓周派對、各式聚會、手作課程、運動活動等多功能的場地，滿足您所有的空間需求。'
            },
            {
                icon: 'seo_pin_drop',
                title: '服務範圍廣泛，全台皆有空間',
                p: '空間便利店的服務範圍遍及全台灣各大主要城市，包含台北、新北、台中、台南、高雄等地，無論您身在何處，都能輕鬆透過空間便利店找到方便租借的優質場地。'
            }
        ]
    }
};



// 派對抓周生日聚會 prod:52
const partyVenueSeo = {
    section0: {
        h1: '抓周與生日派對場地租借，玩出精彩慶典！',
        p: '想讓抓周或生日派對嗨翻天？空間便利店的優質服務，幫你搞定場地選擇、租借流程與超值優惠，輕鬆打造充滿活力的慶祝盛會！'
    },
    section1: {
        resultTitle: '派對抓周生日聚會場地',
        h2: '爆款場地價格與租借方案大公開',
        p: '我們提供各式各樣的派對場地選擇，從時租、日租到包場服務應有盡有。不論是家庭聚會還是狂歡派對，都能找到讓您心動的超值方案，讓活動充滿活力！'
    },
    section2: {
        h2: '多元場地選擇，點燃每一刻歡樂',
        list: [
            { p1: '溫馨家庭派對場地', p: '專為抓周和小型生日派對打造，營造親情滿滿又不失溫暖的慶典氛圍。' },
            { p1: '朋友狂歡派對場地', p: '適合熱鬧生日與朋友聚會，寬敞空間助你和夥伴一起high翻全場。' },
            { p1: '豪華包場尊榮場地', p: '提供頂級設備與豪華環境，讓大型慶典派對更顯尊貴氣派，成就難忘回憶。' }
        ]
    },
    section3: {
        h2: '抓周與生日派對怎麼訂？熱門疑問活力解答',
        list: [
            {
                h3: 'Q1：怎麼快速搞定場地預訂？',
                subTitle: '只需三個輕鬆步驟，馬上上手！',
                ul: [
                    '選擇心儀的場地與理想日期，點擊「立即預訂」！',
                    '填寫活動資訊並完成快速線上付款。',
                    '收到確認信後，帶著好心情到場地現場報到。'
                ]
            },
            {
                h3: 'Q2：如果派對延長怎麼辦？',
                subTitle: '請當場提前通知，讓歡樂延長能順利無礙！',
                ul: []
            },
            {
                h3: 'Q3：場地租借會提供哪些設備？',
                subTitle: '場地都有配備齊全，讓您的派對更盡興：桌椅、音響、Wi-Fi等，詳見各場地設備說明！',
                ul: []
            }
        ]
    },
    section4: {
        h2: '全台抓周與生日派對場地租借，就選空間便利店！',
        list: [
            {
                icon: 'seo_search',
                title: '快速搜尋，方便又好玩',
                p: '利用我們超靈敏的搜尋功能，迅速找到符合派對主題的理想場地，預訂流程簡單到令人驚喜！'
            },
            {
                icon: 'seo_house',
                title: '多元場地，打造獨特派對風格',
                p: '不論你想要低調溫馨還是狂歡熱舞，我們的場地選項豐富多樣，滿足你所有的創意慶典夢想。'
            },
            {
                icon: 'seo_pin_drop',
                title: '地點多元，隨時隨地嗨起來',
                p: '我們整合全國各地人氣場地，無論你身在何處，都能迅速預訂到適合抓周與生日派對的熱點場所。'
            }
        ]
    }
};

// 記者會發表會辦活動 prod:53
const eventVenueSeo = {
    section0: {
        h1: '活動、發表會、記者會場地輕鬆預訂，嗨翻全場！',
        p: '準備辦活動卻還在煩惱找場地？我們的租借平台讓您輕鬆搞定記者會、產品發表會及各式精彩活動！透過空間便利店，享受快速搜尋、彈性租借，讓您的活動充滿驚喜與活力。'
    },
    section1: {
        resultTitle: '記者會發表會辦活動場地',
        h2: '各式活動場地租借方案與超值價格大公開',
        p: '無論是小型聚會還是盛大發表會，我們提供多樣場地選擇與彈性租借方案，包括時段、日租及月租。每個場地都經過精挑細選，保證讓您的活動氣氛炸裂！'
    },
    section2: {
        h2: '多元場地類型：讓活動現場瞬間燃起熱情',
        list: [
            { p1: '輕鬆小聚場地', p: '適合舉辦小型派對、創意工作坊及快閃活動，空間精緻又充滿個性，讓每場小聚都變得獨一無二。' },
            { p1: '炫酷發表會場地', p: '理想場地適合新品發表、記者會與企業聚會，配備先進視聽設備，為您的活動注入滿滿科技感。' },
            { p1: '盛大活動主舞台', p: '超適合大型記者會、品牌發布會及國際研討會，寬敞豪華的空間配合專業燈光音響，讓活動氣勢磅礴。' }
        ]
    },
    section3: {
        h2: '預訂全攻略：場地租借常見問題快解答',
        list: [
            {
                h3: 'Q1：怎麼輕鬆預訂夢幻場地？',
                subTitle: '只需三步驟，預訂流程簡單到不行！',
                ul: [
                    '選擇心儀日期與場地，點擊「立即預訂」。',
                    '填寫活動資訊並完成線上付款。',
                    '活動當日出示訂單ID，輕鬆入場！'
                ]
            },
            {
                h3: 'Q2：如果使用時間延長怎麼辦？',
                subTitle: '若有調整需求，請當場提前告知！',
                ul: []
            },
            {
                h3: 'Q3：場地租借都包含哪些炫酷設施？',
                subTitle: '大部分場地都提供高速Wi-Fi、投影設備、專業音響及照明，讓活動效果更上一層樓！',
                ul: []
            }
        ]
    },
    section4: {
        h2: '想辦活動、發表會或記者會？選空間便利店，讓現場燃爆！',
        list: [
            {
                icon: 'seo_search',
                title: '超速搜尋，快速配對',
                p: '直覺式搜尋功能讓您輕鬆找到心儀場地，快速鎖定最佳方案，讓準備工作事半功倍。'
            },
            {
                icon: 'seo_house',
                title: '多元選擇，滿足各種創意需求',
                p: '不論是小型聚會還是盛大活動，豐富多樣的場地任您挑選，讓每場活動都充滿驚喜。'
            },
            {
                icon: 'seo_pin_drop',
                title: '全台覆蓋，隨時隨地辦活動',
                p: '空間便利店遍布全台主要城市，無論北中南都能輕鬆預訂，讓您的活動場地觸手可及。'
            }
        ]
    }
};


// 運動健身瑜伽舞蹈 prod:55
const fitnessVenueSeo = {
    section0: {
        h1: '運動健身、瑜伽與舞蹈場地預訂，開啟健康生活！',
        p: '無論您是健身教練、瑜伽老師或舞蹈培訓機構，租借運動、瑜伽與舞蹈場地都是推動健康生活與藝術創意的最佳選擇。透過我們的平台，輕鬆找到理想空間，為您的課程和活動增添動力！'
    },
    section1: {
        resultTitle: '運動健身瑜伽舞蹈場地',
        h2: '運動健身、瑜伽與舞蹈場地租借價格與方案總覽',
        p: '我們提供多樣化的運動、瑜伽及舞蹈場地選擇，搭配靈活租借方案，如時租、時段租與日租，滿足不同規模與需求，讓您的課程和活動更輕鬆規劃。'
    },
    section2: {
        h2: '場地類型介紹：運動、瑜伽與舞蹈空間多樣應用',
        list: [
            {
                h3: '功能專屬訓練室',
                p: '專為個人與小組打造，適合進行重量訓練與心肺運動，提供完善設施與舒適環境，激發無限活力。'
            },
            {
                h3: '靜心瑜伽空間',
                p: '專為瑜伽、冥想與伸展設計，營造安靜寧和的氛圍，助您放鬆身心、追求內在平衡。'
            },
            {
                h3: '動感舞蹈表演廳',
                p: '擁有專業舞台設計與音響設備，適合舞蹈訓練與公開表演，讓藝術與激情完美融合。'
            }
        ]
    },
    section3: {
        h2: '場地租借預約流程與常見疑問',
        list: [
            {
                h3: 'Q1：如何預訂運動、瑜伽或舞蹈場地？',
                subTitle: '只需簡單3步驟，輕鬆完成預訂。',
                ul: [
                    '選擇合適的場地與租借時段，點擊「立即預訂」按鈕。',
                    '完成線上付款後，即可收到預訂確認信。',
                    '到場時出示訂單ID，即享專業場地服務。'
                ]
            },
            {
                h3: 'Q2：租借場地時間延長該如何處理？',
                subTitle: '如需延長請當場提前聯繫我們。',
                ul: []
            },
            {
                h3: 'Q3：場地租借包含哪些基本設施？',
                subTitle: '各場地配置略有不同，有如下設施，如鏡子、音響、地墊及更衣室，同時還配備LED照明、空調、無線網路、燈光及影音設備，確保活動順利進行。',
                ul: []
            }
        ]
    },
    section4: {
        h2: '全台運動、瑜伽與舞蹈場地租借首選 — 就選空間便利店！',
        list: [
            {
                icon: 'seo_search',
                title: '便捷搜尋，快速定位',
                p: '透過先進的關鍵字搜尋功能，迅速篩選出符合您課程需求的運動、瑜伽與舞蹈場地，節省寶貴時間。'
            },
            {
                icon: 'seo_house',
                title: '多元場地，靈活選擇',
                p: '我們整合全台各式運動、瑜伽及舞蹈空間，無論小班教學或大型活動，都能滿足您的各種需求。'
            },
            {
                icon: 'seo_pin_drop',
                title: '智慧平台，安心預約',
                p: '運用大數據分析與用戶反饋，我們精準推薦符合您需求的理想場地，讓每一次預訂都充滿信心與保障。'
            }
        ]
    }
};



// 美容美甲美儀按摩 prod:56
const beautyVenueSeo = {
    section0: {
        h1: '美容美甲美儀按摩場地租借首選，專業美學空間輕鬆預訂！',
        p: '美容美甲美儀按摩場地租借是美容師、技術專家及健康顧問的熱門選擇，透過專業平台快速找到理想的美學空間，助您展現極致魅力！下方我們整理了美容美甲美儀按摩場地租借常見問題，詳細介紹租借方案、價格、預約流程及人氣場地推薦，供您參考。'
    },
    section1: {
        resultTitle: '美容美甲美儀按摩場地',
        h2: '美容美甲美儀按摩場地租借價格與方案全攻略',
        p: '我們提供多元化的美容美甲美儀按摩場地選項，並搭配靈活租借方案，如時租、時段租、日租與月租，無論您是獨立工作室或高端沙龍，都能在此找到最符合需求的美學空間。'
    },
    section2: {
        h2: '如何挑選理想美學空間？美容美甲美儀按摩場地多樣風格介紹',
        list: [
            { p1: '私密個人美學工作間', p: '適合個人美甲、美儀或按摩服務，提供溫馨舒適的私密環境，專為精緻服務量身打造。' },
            { p1: '多功能美學創意坊', p: '適合團體課程、工作坊及產品體驗活動，開放式空間兼具設計感與實用性，激發創意思維。' },
            { p1: '高端養生美容沙龍', p: '適用於高級療程、專業展示與講座，豪華環境搭配專業設備，打造極致美學體驗。' }
        ]
    },
    section3: {
        h2: '美容美甲美儀按摩場地預約流程與常見疑問',
        list: [
            {
                h3: 'Q1：如何預訂美容美甲美儀按摩場地？',
                subTitle: '只需簡單 3 步驟，即可完成預訂。',
                ul: [
                    '選擇所需日期與時段，點擊「立即預訂」按鈕。',
                    '完成付款程序後，您將收到詳細預訂資訊的確認信。',
                    '活動當天，攜帶訂單 ID 現場驗證，輕鬆使用空間。'
                ]
            },
            {
                h3: 'Q2：租借時間超時該如何處理？',
                subTitle: '為保障所有用戶權益，請務必在預訂時間內使用場地，如有延長請當場提前告知。',
                ul: []
            },
            {
                h3: 'Q3：場地租借包含哪些基本配套設施？',
                subTitle: '各場地設施會有所不同，但基本設備如桌椅、燈光、音響與Wi-Fi等均有提供，滿足基本營運需求。',
                ul: []
            }
        ]
    },
    section4: {
        h2: '選擇美容美甲美儀按摩場地，就選空間便利店，打造專屬美學體驗！',
        list: [
            {
                icon: 'seo_search',
                title: '快速搜尋，預訂零等待',
                p: '利用精準關鍵字搜尋功能，系統能快速篩選出符合您美學主題的場地，為您節省寶貴時間。'
            },
            {
                icon: 'seo_house',
                title: '多樣空間，滿足各類美學需求',
                p: '從私密個人工作間到多功能創意坊，再到高端養生沙龍，我們提供豐富場地選擇，讓您的服務更臻完美。'
            },
            {
                icon: 'seo_pin_drop',
                title: '專業服務，量身打造獨特美學體驗',
                p: '我們與各地優質場地合作，提供全方位支援，從場地規劃到現場管理，助您輕鬆實現品牌升級。'
            }
        ]
    }
};


// 攝影錄音直播 prod:54
const studioSpaceSeo = {
    section0: {
        h1: '專業攝影、錄音與直播場地預訂 — 高效三步驟搞定！',
        p: '無論您是專業攝影師、音樂製作人或直播達人，我們提供的創作場地均具備先進設備與完善配套，助您在創作過程中展現最佳實力。下方詳解場地租借流程、價格方案及常見問答，讓您快速掌握專業租借資訊。'
    },
    section1: {
        resultTitle: '攝影錄音直播場地',
        h2: '場地租借費用與方案解析 — 精選創作空間推薦',
        p: '我們精心挑選各式創作場地，提供靈活的時租、段租與日租方案，滿足不同創作需求。無論是小規模試拍或大型錄音、直播活動，都能找到理想場地。'
    },
    section2: {
        h2: '多元創作場地類型與應用領域深度解析',
        list: [
            { p1: '主題攝影工作室', p: '設計獨具匠心，適合人像、產品及創意拍攝，並配備專業燈光與後製設備，助您捕捉每個精彩瞬間。' },
            { p1: '專業錄音室', p: '擁有高端錄音器材及優異隔音效果，無論音樂製作、Podcast錄製或廣播節目，都能提供完美聲音呈現。' },
            { p1: '高規格直播現場', p: '配備頂尖網路設備與專業燈光設計，適用於大型線上活動、產品發布與直播節目，確保畫面與聲音品質達到業界標準。' }
        ]
    },
    section3: {
        h2: '專業場地租借流程及常見問題詳解',
        list: [
            {
                h3: 'Q1：如何預訂專業攝影、錄音或直播場地？',
                subTitle: '透過簡便三步驟，快速完成預訂流程。',
                ul: [
                    '選擇適合的日期與時段，點選「立即預訂」按鈕。',
                    '完成安全付款，即可收到詳細預訂確認資訊。',
                    '於預訂當日出示訂單編號，順利進入場地使用。'
                ]
            },
            {
                h3: 'Q2：若預訂後因特殊情況需調整時間該如何處理？',
                subTitle: '請盡早聯絡客服，確保服務不中斷。',
                ul: []
            },
            {
                h3: 'Q3：場地租借包含哪些專業設備？',
                subTitle: '配置設備依據各場地不同，如專業燈光、音響、網路連線與後製設施，助力創作過程無縫銜接。',
                ul: []
            }
        ]
    },
    section4: {
        h2: '找專業攝影、錄音與直播場地？空間便利店值得信賴！',
        list: [
            {
                icon: 'seo_search',
                title: '智能搜尋，效率領先',
                p: '利用精準關鍵字搜尋技術，系統能迅速鎖定符合您需求的專業創作場地，極大提升預訂效率。'
            },
            {
                icon: 'seo_house',
                title: '多元場地，全面滿足創作需求',
                p: '我們提供多種場地選項，無論是試拍、音樂錄製或直播活動，都能找到配置完善、技術先進的專業空間。'
            },
            {
                icon: 'seo_pin_drop',
                title: '跨區域覆蓋，助力創作無界',
                p: '空間便利店覆蓋全國主要創作熱點，讓每位創作者都能輕鬆找到符合需求的優質場地，拓展創作版圖。'
            }
        ]
    }
};


// 表演音樂戲劇 prod:57
const performanceVenueSeo = {
    section0: {
        h1: '表演、音樂、戲劇場地租借輕鬆上手，開啟藝術之旅！',
        p: '無論您是音樂家、劇團或藝術創作者，選對表演場地能讓活動更精彩！下方我們整理了表演、音樂與戲劇場地租借的常見疑問，詳解租借流程、方案與價格，助您輕鬆找到理想空間！'
    },
    section1: {
        resultTitle: '表演音樂戲劇場地',
        h2: '表演場地租借價格解析及多元租借方案',
        p: '我們提供豐富多樣的表演、音樂及戲劇場地，並搭配按場次、時段或全天候租借的彈性選項，讓每位藝術家與團隊都能輕鬆找到最適合的創作空間！'
    },
    section2: {
        h2: '場地選擇指南：依功能特色分類的表演空間',
        list: [
            { p1: '音樂會演出場', p: '適合小型音樂會、獨奏或樂團排練，空間配置專為聲學效果而設，營造出獨特現場氛圍。' },
            { p1: '戲劇舞台空間', p: '專為戲劇演出、劇本朗讀及工作坊設計，擁有專業燈光、舞台設備，助力演出呈現最佳效果。' },
            { p1: '多元表演場域', p: '適合舉辦大型演唱會、綜藝節目與戶外活動，場域寬敞，能容納眾多觀眾，讓演出更具震撼力。' }
        ]
    },
    section3: {
        h2: '表演場地租借流程與常見疑問',
        list: [
            {
                h3: 'Q1：如何預訂表演場地？',
                subTitle: '只需簡單 3 個步驟即可完成預約。',
                ul: [
                    '挑選心儀場地與合適日期，點選「立即預約」。',
                    '確認設備與配置後完成付款流程。',
                    '租借當天，出示訂單 ID 即可順利入場。'
                ]
            },
            {
                h3: 'Q2：租借場地使用時間超出怎麼辦？',
                subTitle: '請依約使用場地，如有延長需求，請提前聯繫我們。',
                ul: []
            },
            {
                h3: 'Q3：場地租借包含哪些基本設施？',
                subTitle: '各場地設備配置略有不同，但基本上皆提供音響、燈光與舞台設施，滿足演出需求。',
                ul: []
            }
        ]
    },
    section4: {
        h2: '找尋專業表演場地，就選空間便利店平台',
        list: [
            {
                icon: 'seo_search',
                title: '快速搜尋，精準匹配',
                p: '利用智能關鍵字搜尋，系統能迅速為您篩選出符合各種表演需求的場地，節省寶貴時間。'
            },
            {
                icon: 'seo_house',
                title: '多元場地，任君挑選',
                p: '從室內音樂廳到戶外劇場，乃至創意表演空間，我們提供多樣場地選擇滿足各種創作需求。'
            },
            {
                icon: 'seo_pin_drop',
                title: '平台精選，專屬表演場地',
                p: '精心挑選的表演場地，提供獨家租借方案，助您打造難忘的藝術活動體驗。'
            }
        ]
    }
};


// 多用途空間 prod:60
const multiSpaceSeo = {
    section0: {
        h1: '多用空間預訂輕鬆搞定，3步驟迅速上手！',
        p: '多用空間的靈活運用，為您的活動、聚會或創作提供無限可能！下方整理了多用空間常見問題、方案選擇、價格與預約流程，助您輕鬆找到理想場地，讓每個計劃都能順利進行。'
    },
    section1: {
        resultTitle: '多用途空間',
        h2: '多用空間價格與方案全解析',
        p: '我們提供豐富多元的空間選擇，無論是短時租、日租或長租方案，都能滿足各種活動需求，帶來最佳的空間體驗。'
    },
    section2: {
        h2: '多用空間分類與創新用途說明',
        list: [
            { p1: '都市創意空間', p: '專為城市生活打造，適合創意會議、藝術展覽與小型聚會等活動。' },
            { p1: '鄉村休閒空間', p: '遠離都市喧囂，提供悠閒放鬆的環境，適合團建活動或親子休閒。' },
            { p1: '多功能社區空間', p: '靈活多變的配置，適用於講座、工作坊及社區活動等多種用途。' }
        ]
    },
    section3: {
        h2: '如何輕鬆預約多用空間？常見疑問解答',
        list: [
            {
                h3: 'Q1：如何預訂多用空間？',
                subTitle: '只需3個簡單步驟，輕鬆完成預訂。',
                ul: [
                    '選擇日期與時間，點擊「立即預訂」按鈕。',
                    '完成付款後，您將收到確認詳情的通知。',
                    '當天出示訂單 ID，即可使用預訂場地。'
                ]
            },
            {
                h3: 'Q2：若預訂的多用空間有延時該怎麼處理？',
                subTitle: '請務必遵守預訂時間，若需延長請提前與我們聯繫。',
                ul: []
            },
            {
                h3: 'Q3：多用空間是否包含基本設施？',
                subTitle: '各空間標配設施有所不同，但基本設施如Wi-Fi、桌椅及插頭等。',
                ul: []
            }
        ]
    },
    section4: {
        h2: '多元空間選擇，盡在您的掌握！',
        list: [
            {
                icon: 'seo_search',
                title: '快速搜尋，節省預訂時間',
                p: '透過精準的關鍵字搜尋功能，輕鬆篩選出符合需求的多用空間，助您快速找到理想場地。'
            },
            {
                icon: 'seo_house',
                title: '多元場地，激發創意靈感',
                p: '我們平台提供各式各樣的場地，無論是創意工作室、藝術展覽或聚會場所，都能輕鬆預訂。'
            },
            {
                icon: 'seo_pin_drop',
                title: '專業平台，創新場地',
                p: '我們致力於提供創新、多元的場地解決方案，無論是商務、藝術還是社群活動，都能在此找到獨具風格的空間。'
            }
        ]
    }
};



const seoMap = {
    // 49: meetingRoomSeo,
    // 50: meetingRoomSeo,
    'meeting-room': meetingRoomSeo,
    'party': partyVenueSeo,
    'event': eventVenueSeo,
    'studio': studioSpaceSeo,
    'fitness': fitnessVenueSeo,
    'beauty': beautyVenueSeo,
    'performance': performanceVenueSeo,
    'multi-room': multiSpaceSeo
};


const getSeoText = (id) => {

    return seoMap[id] || null
}


export {seoMap, getSeoText}
